import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderPp } from "../../../components/Landing/Header/haederPp";
import { Footer } from "../../../components/Landing/Footer";
import '../PeopleList.scss';
import segundaDesktop from "../../../assets/pp/BANNER-PAGINA-WEB-FORTALECIMIENTO-2026.jpeg";
const observatorio = process.env.PUBLIC_URL + encodeURI("/assets/pp/observatorio.png");
const investigacion = process.env.PUBLIC_URL + encodeURI("/assets/pp/investigacion.png");
const planes = process.env.PUBLIC_URL + encodeURI("/assets/pp/planes.png");
// style
import "../landing.style.scss";
import { CarouselCustom } from "../components/Carousel/CarouselCustom";


export const PpFortalecimiento = () => {

  return (
    <div>
      <Header />
      <HeaderPp />
      <CarouselCustom
        images={[
          { src: segundaDesktop, alt: "Banner 1" }
        ]}
      />
      <div className="container-fluid2 pt-5" style={{ marginTop: '0' }}>
        <div className="font-family-Montserrat text-center font-color-black" style={{ fontSize: 60 }}>
          <strong>
            <h1 className="mb-5" style={{ color: '#1e3a53' }}>
              Fortalecimiento al Sector Cultural
            </h1>
          </strong>
          <h4 className="mb-3" style={{ textAlign: 'center', marginTop: '10px' }}>
            Este componente busca consolidar el sector cultural en las comunas y corregimientos de Medellín mediante el fortalecimiento de artistas, gestores, organizaciones y redes. Sus acciones incluyen la formulación de planes de desarrollo cultural, la dinamización de redes y colectivos, y la oferta de diplomados en gestión cultural y otros temas relevantes.
          </h4>
        </div>
      </div>
      <br />
      <div className="container-fluid2 pt-5">
        <div className="row justify-content-center">
          <div className="col-md-3">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={observatorio}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Observatorio</h3>
                  <p className="card2-description">
                    Es una herramienta que sirve para observar y analizar tendencias en un área específica. Tiene claro qué estudia, cómo lo hace y con qué principios. Su objetivo es ofrecer información con una mirada crítica, independiente y diversa. Funciona como un centro de ideas que promueve el análisis y la difusión de lo que descubre sobre el tema que investiga.
                  </p>
                  <p className="card2-description">
                    El observatorio se desarrolla en tres etapas, pero solo se podrá ejecutar una por vigencia o anualidad.
                  </p>
                  <p className="card2-description">
                    <strong>Nota:</strong> Al finalizar alguna de estas actividades, se podrá realizar una muestra artística
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={investigacion}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Investigación en Fortalecimiento al Sector Cultural.</h3>
                  <p className="card2-description">
                    Consiste en un proceso metódico, sistemático y ordenado, cuyo propósito es responder preguntas, teorías o hipótesis relacionadas con el fortalecimiento del sector cultural en las comunas y corregimientos de Medellín. Su desarrollo permite la generación de conocimiento y la obtención de información relevante.
                  </p>
                  <p className="card2-description">
                    <strong>Nota:</strong> Al finalizar alguna de estas actividades, se podrá realizar una muestra artística
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={planes}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Planes de trabajo o gestión.</h3>
                  <p className="card2-description">
                    Es una herramienta de planeación que permite a organizaciones, colectivos, mesas y agrupaciones culturales operar de manera articulada, coordinada e integral. Incluye la definición de objetivos, directrices, políticas, estrategias, metas y acciones para fortalecer el sector cultural.
                  </p>
                  <p className="card2-description">
                    La formulación del plan de trabajo contempla 3 etapas fundamentales:
                  </p>
                  <p className="card2-description">
                    - Formulación
                  </p>
                  <p className="card2-description">
                    - Ejecución
                  </p>
                  <p className="card2-description">
                    - Evaluación
                  </p>
                  <p className="card2-description">
                    <strong>Nota:</strong> Al finalizar alguna de estas actividades, se podrá realizar una muestra artística
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={observatorio}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Fortalecimiento del tejido cultural - Encuentros de aprendizaje</h3>
                  <p className="card2-description">
                    Busca fortalecer los procesos pedagógicos y el intercambio de saberes dentro del sector cultural a través de diferentes formatos de aprendizaje:
                  </p>
                  <p className="card2-description">
                    - Diplomados
                  </p>
                  <p className="card2-description">
                    - Seminarios
                  </p>
                  <p className="card2-description">
                    - Conferencias
                  </p>
                  <p className="card2-description">
                    - Encuentros Formativos
                  </p>
                  <p className="card2-description">
                    - Foros
                  </p>
                  <p className="card2-description">
                    - Simposios
                  </p>
                  <p className="card2-description">
                    - Tertulias
                  </p>
                  <p className="card2-description">
                    - Diálogos de Saberes
                  </p>
                  <p className="card2-description">
                    - Conversatorios
                  </p>
                  <p className="card2-description">
                    <strong>Nota:</strong> Al finalizar alguna de estas actividades, se podrá realizar una muestra artística
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
